import { imageSizes, buildImageUrl } from '../utils/images';

import type { Image } from '../types/Image/Image';

type Props = {
  record?: { image?: Image; name?: string };
  size?: string;
  linkToFull?: boolean;
  className?: string;
};

const ImageUpload = ({ record: { image, name }, size, linkToFull = false, ...imageProps }: Props) => {
  if (!image) {
    return null;
  }

  const img = (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={buildImageUrl(image, size)}
      alt={name}
      style={imageSizes[size]}
      {...imageProps}
    />
  );

  if (linkToFull) {
    return (
      <a
        href={buildImageUrl(image, 'full')}
        target="_blank"
        rel="noopener noreferrer"
      >
        {img}
      </a>
    );
  }

  return img;
};

export default ImageUpload;
